/*
 * ASORTI (toptan lot siparisi) — istemci mantigi.
 *
 * Urun sayfasi:
 *   - Lot adedi stepper'i; matris toplamlari (adet/fiyat) canli guncellenir.
 *   - "Sepete Ekle": her beden = birim adet x lot adedi; tek /cart/add.js cagrisi.
 *     Her satira _asorti/_lot/_lot_per/... property'leri yazilir (sepette gruplamak icin).
 *   - Basari -> sepet sayfasina git (drawer kapali).
 *
 * Sepet sayfasi:
 *   - Sunucuda gruplanan .asorti-cart-lot kartlari; +/- lot adedini degistirir,
 *     "Lotu kaldir" gruptaki TUM satirlari siler. Tek /cart/update.js -> reload.
 */
(function () {
  'use strict';

  function fmtMoney(cents, currency) {
    var v = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr', {
        style: 'currency',
        currency: currency || 'TRY',
      }).format(v);
    } catch (e) {
      return v.toFixed(2);
    }
  }

  function getLots(input, min) {
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < min) n = min;
    return n;
  }

  // ---------------- Urun sayfasi ----------------
  function recalcLot(lotEl) {
    var input = lotEl.querySelector('[data-asorti-lots]');
    var min = parseInt(lotEl.dataset.minLots, 10) || 1;
    var lots = getLots(input, min);
    input.value = lots;

    lotEl.querySelectorAll('[data-asorti-cell-total]').forEach(function (cell) {
      var per = parseInt(cell.dataset.per, 10) || 0;
      cell.textContent = per * lots;
    });

    var perTotal = parseInt(lotEl.dataset.perTotal, 10) || 0;
    var piecesEl = lotEl.querySelector('[data-asorti-total-pieces]');
    if (piecesEl) piecesEl.textContent = perTotal * lots;

    var priceEl = lotEl.querySelector('[data-asorti-unit-price]');
    if (priceEl) {
      var unit = parseInt(priceEl.dataset.asortiUnitPrice, 10) || 0;
      var root = lotEl.closest('[data-asorti-root]');
      var currency = root ? root.dataset.currency : 'TRY';
      priceEl.textContent = fmtMoney(unit * lots, currency);
    }
  }

  async function addLot(btn) {
    var lotEl = btn.closest('[data-asorti-lot]');
    var root = lotEl.closest('[data-asorti-root]');
    var errEl = lotEl.querySelector('[data-asorti-error]');
    var input = lotEl.querySelector('[data-asorti-lots]');
    var min = parseInt(lotEl.dataset.minLots, 10) || 1;
    var lots = getLots(input, min);

    var items;
    try {
      items = JSON.parse(btn.dataset.items || '[]');
    } catch (e) {
      items = [];
    }
    if (!items.length) return;

    var lotCode = btn.dataset.lotCode || '';
    var color = btn.dataset.lotColor || '';

    var payload = {
      items: items.map(function (it) {
        return {
          id: it.id,
          quantity: it.per * lots,
          properties: {
            _asorti: '1',
            _lot: lotCode,
            _lot_color: color,
            _lot_size: String(it.size),
            _lot_per: String(it.per),
            _lot_min: String(min),
          },
        };
      }),
    };

    btn.setAttribute('disabled', 'disabled');
    if (errEl) errEl.hidden = true;

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        window.location.href = (root && root.dataset.cartUrl) || '/cart';
        return;
      }
      var data = await res.json().catch(function () { return {}; });
      if (errEl) {
        errEl.textContent = data.description || data.message || ((document.documentElement.lang || '').indexOf('en') === 0 ? 'Could not add to cart.' : 'Sepete eklenemedi.');
        errEl.hidden = false;
      }
    } catch (e) {
      if (errEl) {
        errEl.textContent = (document.documentElement.lang || '').indexOf('en') === 0 ? 'Connection error, please try again.' : 'Bağlantı hatası, tekrar deneyin.';
        errEl.hidden = false;
      }
    } finally {
      btn.removeAttribute('disabled');
    }
  }

  // ---------------- Sepet sayfasi ----------------
  async function updateCartGroup(cardEl, lots) {
    var keys;
    try {
      keys = JSON.parse(cardEl.dataset.keys || '[]');
    } catch (e) {
      keys = [];
    }
    if (!keys.length) return;

    var updates = {};
    keys.forEach(function (k) {
      updates[k.key] = lots > 0 ? k.per * lots : 0;
    });

    cardEl.classList.add('is-busy');
    try {
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      if (res.ok) {
        window.location.reload();
        return;
      }
    } catch (e) {
      /* yut */
    }
    cardEl.classList.remove('is-busy');
  }

  function onCartCardClick(cardEl, action) {
    var min = parseInt(cardEl.dataset.minLots, 10) || 1;
    var current = parseInt(cardEl.dataset.lots, 10) || min;
    if (action === 'plus') {
      updateCartGroup(cardEl, current + 1);
    } else if (action === 'minus') {
      var next = current - 1;
      if (next < min) next = min; // min altina inme; kaldirmak icin "Lotu kaldir"
      if (next === current) return;
      updateCartGroup(cardEl, next);
    } else if (action === 'remove') {
      updateCartGroup(cardEl, 0);
    }
  }

  // ---------------- Delege dinleyiciler ----------------
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-asorti-add]');
    if (addBtn) {
      e.preventDefault();
      addLot(addBtn);
      return;
    }

    var plus = e.target.closest('[data-asorti-plus]');
    var minus = e.target.closest('[data-asorti-minus]');
    if (plus || minus) {
      var lotEl = (plus || minus).closest('[data-asorti-lot]');
      if (lotEl) {
        var input = lotEl.querySelector('[data-asorti-lots]');
        var min = parseInt(lotEl.dataset.minLots, 10) || 1;
        var lots = getLots(input, min);
        input.value = plus ? lots + 1 : Math.max(min, lots - 1);
        recalcLot(lotEl);
      }
      return;
    }

    var cartCard = e.target.closest('.asorti-cart-lot');
    if (cartCard) {
      if (e.target.closest('[data-asorti-cart-plus]')) { onCartCardClick(cartCard, 'plus'); return; }
      if (e.target.closest('[data-asorti-cart-minus]')) { onCartCardClick(cartCard, 'minus'); return; }
      if (e.target.closest('[data-asorti-cart-remove]')) { onCartCardClick(cartCard, 'remove'); return; }
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-asorti-lots]');
    if (input) {
      var lotEl = input.closest('[data-asorti-lot]');
      if (lotEl) recalcLot(lotEl);
    }
  });

  var LETTER_RANK = {
    xxs: 10,
    xs: 20,
    s: 30,
    m: 40,
    l: 50,
    xl: 60,
    xxl: 70,
    '2xl': 70,
    xxxl: 80,
    '3xl': 80,
    xxxxl: 90,
    '4xl': 90,
  };

  function normalizeSizeLabel(raw) {
    return String(raw == null ? '' : raw)
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/xxxxl/g, '4xl')
      .replace(/xxxl/g, '3xl')
      .replace(/xxl/g, '2xl');
  }

  function sizeRank(raw) {
    var s = normalizeSizeLabel(raw);
    var range = s.match(/^(\d+(?:\.\d+)?)[/\-](\d+(?:\.\d+)?)$/);
    if (range) return 100 + parseFloat(range[1]);
    if (/^\d+(?:\.\d+)?$/.test(s)) return 100 + parseFloat(s);
    if (LETTER_RANK[s] != null) return LETTER_RANK[s];
    return 1000;
  }

  function sortProductLotMatrices() {
    document.querySelectorAll('[data-asorti-lot]').forEach(function (lotEl) {
      var tbody = lotEl.querySelector('.asorti-matrix tbody');
      if (tbody) {
        var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr'));
        rows.sort(function (a, b) {
          var sa = ((a.querySelector('.asorti-matrix__size') || a.cells[0] || {}).textContent || '').trim();
          var sb = ((b.querySelector('.asorti-matrix__size') || b.cells[0] || {}).textContent || '').trim();
          return sizeRank(sa) - sizeRank(sb);
        });
        rows.forEach(function (row) {
          tbody.appendChild(row);
        });
      }

      var btn = lotEl.querySelector('[data-asorti-add]');
      if (!btn) return;
      try {
        var items = JSON.parse(btn.getAttribute('data-items') || '[]');
        items.sort(function (a, b) {
          return sizeRank(a.size) - sizeRank(b.size);
        });
        btn.setAttribute('data-items', JSON.stringify(items));
      } catch (e) {
        /* yut */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortProductLotMatrices);
  } else {
    sortProductLotMatrices();
  }
})();
